import axios from "axios"

const CuentasContablesService = {
  // GETs
  getNumeroDeCifras() {
    return axios.get("/CuentaContableEmpresa")
  },
  // POSTs
  createCuentaContable(newCuentaContable: $TSMigrationFixMe) {
    return axios.post("/CuentaContableEmpresa", newCuentaContable)
  },

  editCuentaContableEmpresa(
    idCuentaEmpresa: $TSMigrationFixMe,
    cuentaContableEmpresaBody: $TSMigrationFixMe
  ) {
    return axios.put(
      `/CuentaContableEmpresa/${idCuentaEmpresa}`,
      cuentaContableEmpresaBody
    )
  },
  cambiarNumerosDeCifrasDeLasCuentasContables(newDigitos: $TSMigrationFixMe) {
    return axios.put(
      `/EmpresaConfiguracion/digitos-cuentas-contables/${newDigitos}`
    )
  },
}

export default CuentasContablesService
